import React, { useId } from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: {
    value: string | number;
    label: string;
  }[];
  error?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || useId();
  return <div className="w-full" data-id="element-193" data-mp="1qhrdgx37ozxk">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700 mb-1" data-id="element-194" data-mp="1cj9ufco94blz">
          {label}
        </label>}
      <select id={selectId} className={`flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-195" data-mp="1hgt8abh1emde">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-196" data-mp="31xy3p51jpdfs">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-197" data-mp="10v67uhja8su1">{error}</p>}
    </div>;
}